module.exports = __webpack_public_path__ + "catalog/items/firesafety/direction-down/direction-down.svg";